module.exports = __webpack_public_path__ + "img/users-icon.2b09e68b.svg";